import React from 'react'
import { ModalWindow, ModalContent, ModalFooter } from 'view/components/panels/ModalWindow'
import styled from '@emotion/styled'
import { ShowDialogArgs } from 'store/notification'
import { Locale, Translation } from 'locale'
import { TextButton, TextButtonType } from 'view/components/buttons'

export interface DialogBoxProps extends ShowDialogArgs {
  onClose?: (result?: any) => unknown
}

const MessageContainer = styled.div`
  font-size: 14px;
  white-space: pre-line;
`

export class DialogBox extends React.Component<DialogBoxProps> {
  render() {
    const { buttons, onClose } = this.props

    return (
      <ModalWindow title={this.getTitle()}>
        <ModalContent>
          <MessageContainer>{this.getFormattedMessage()}</MessageContainer>
        </ModalContent>

        <ModalFooter>
          {buttons.map(button => (
            <TextButton
              dataTestId={'DialogBox-TextButton-Button'}
              key={button}
              type={this.getButtonType(button)}
              onClick={() => onClose && onClose(button)}>
              {Locale.translate(button)}
            </TextButton>
          ))}
        </ModalFooter>
      </ModalWindow>
    )
  }

  getButtonType(button: Translation) {
    const { defaultButton, cancelButton } = this.props
    if (button === defaultButton) {
      return TextButtonType.Primary
    } else if (button === cancelButton) {
      return TextButtonType.Secondary
    } else {
      return TextButtonType.Tertiary
    }
  }

  getTitle(): string {
    const { title, titleText } = this.props

    if (titleText) {
      return titleText
    } else if (title) {
      return Locale.translate(title)
    } else {
      throw new Error('Either titleText or title must be specified')
    }
  }

  getFormattedMessage(): string | JSX.Element {
    const { message, messageArgs, messageText, messageComponent } = this.props

    if (messageComponent) {
      return messageComponent
    } else if (messageText) {
      return messageText
    } else if (message) {
      return Locale.translate(message, messageArgs)
    } else {
      throw new Error('Either messageComponent, messageText or message must be specified')
    }
  }
}
